import React from 'react';
import Home from './components/Home/index'
function App() {
  return <Home />;
}

export default App;
